import {ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractListView} from "../../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../../shared/actions";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {FormBuilder} from "@angular/forms";
import {Stock} from "../../../../shared/view-model/stock";
import {StockService} from "../../../services/stock.service";

@Component({
  selector: 'vb-expiring-stocks-table',
  templateUrl: './expiring-stocks-table.component.html',
  styleUrls: ['./expiring-stocks-table.component.css']
})
export class ExpiringStocksTableComponent extends AbstractListView implements OnInit {

  private _stocksList: Stock[];

  @Input()
  set stocksList(value: Stock[]) {
    this._stocksList = value;
    this.rows = this.stocksList;
  }

  get stocksList(): Stock[] {
    return this._stocksList || [];
  }

  messages = {
    emptyMessage: 'Keine Bestände mit ablaufenden Chargen',
    totalMessage: 'Bestände mit ablaufenden Chargen'
  };

  batchesComparator: (valueA, valueB, rowA: Stock, rowB: Stock, sortDirection) => number =
    (valueA, valueB, rowA: Stock, rowB: Stock, sortDirection) => {

      if (!rowA.product_batches || !rowA.product_batches.length) {
        return -1;
      }

      if (!rowB.product_batches || !rowB.product_batches.length) {
        return 1;
      }

      const a = <string> rowA.product_batches.map(b => b.use_before_date).sort()[0];
      const b = <string> rowB.product_batches.map(b => b.use_before_date).sort()[0];

      return a.localeCompare(b);
    };

  @ViewChild('batchesTmpl')
  batchesTmpl: TemplateRef<any>;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private stockService: StockService) {
    super(sessionActions, cd);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.searchTerm) {
      this.searchTerm = this.fb.control(null);
    }

    this.addSubscription(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'label', name: 'Bestand'},
      {prop: 'depot.label', name: 'Lager'},
      {prop: 'depot_yard.label', name: 'Lagerplatz'},
      {name: 'MHD / Chargen', cellTemplate: this.batchesTmpl, comparator: this.batchesComparator},
    ];

  }


  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.stocksList;
    } else {
      if (this.stocksList) {
        this.rows = this.stocksList.filter((si: Stock) => {

          const d = this.findStringInTable(si, this.columns, searchTerm);
          if (d) {
            return true;
          }

          return si.product_batches
            .map(pb => pb.label)
            .findIndex(pb => pb.includes(searchTerm)) != -1
        });
      }
    }
  }

  deleteProductBatchFromStock(productBatchCuid: string, stockCuid: string) {
    console.info("Delete batch " + productBatchCuid + ' from stock ' + stockCuid);
    this.stockService.removeProductBatchFromStock(stockCuid, productBatchCuid).toPromise()
      .then(res => {
        console.info("Removed " + res.data.removeProductBatchFromStock);
      })
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen der Charge!"));
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/components/expiring-stocks-table/expiring-stocks-table.component.ts